import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const ManageGradProgramPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/ManageGradProgramPageContainerLoadable" */
      './ManageGradProgramPageContainer'
    ),
  loading: LoadableLoadingSection,
});
